import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import MetamaskLogo from '../../img/Metamask.png';
import SupplyChainContract from '../../contracts/SupplyChainContract';

const LoginPage = ({ onLogin }) => {
  const [metaMaskError, setMetaMaskError] = useState(false);

  const history = useHistory();

  const addresses = {
    owner: '0x8cD1F43f31E151e522f036C8e5a3ba1E49Ae0d75',
  };

  const handleLogin = async () => {
    try {
      if (window.ethereum) {
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
  
        const accountAddress = accounts[0];
  
        if (accountAddress.toLowerCase() === addresses.owner.toLowerCase()) {
          onLogin('admin'); 
          history.push('/admin');
          return;
        }
  
        const userRole = await SupplyChainContract.methods.userRoles(accountAddress).call();
  
        let role = '';
        switch (userRole) {
          case '0':
            role = 'farmer';
            break;
          case '1':
            role = 'inspector';
            break;
          case '2':
            role = 'distributor';
            break;
          case '3':
            role = 'retailer';
            break;
          default:
            console.error('User role not recognized.');
            return;
        }
  
        onLogin(role);
  
        history.push(`/${role}`);
      } else {
        console.error('MetaMask not installed.');
        setMetaMaskError(true);
      }
    } catch (error) {
      console.error('Error during login:', error);
    }
  };
  
  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 pt-16">
      <div className="p-10 bg-gray-200 rounded shadow-2xl w-96 mt-[-50px]">
        <h2 className="text-3xl font-semibold mb-10 text-center">Login</h2>
        <button
          onClick={handleLogin}
          className="flex items-center justify-center bg-blue-500 text-white w-full py-3 rounded hover:bg-blue-600 focus:outline-none"
        >
          <img src={MetamaskLogo} alt="MetaMask Logo" className="w-6 h-6 mr-2" />
          Login with MetaMask
        </button>
        {metaMaskError && <p className="mt-4 text-red-500 text-center">MetaMask not detected!</p>}
      </div>
    </div>
  );
};

export default LoginPage;